import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Table, Tag } from 'antd';

const backend_url = process.env.REACT_APP_BACKEND_URL
const UserData = () => {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const { data } = await axios.get(`${backend_url}/api/get-all-users`);
        setUsers(data);
      } catch (error) {
        console.error('Error fetching users:', error);
      }
    };

    fetchUsers();
  }, []);

  const columns = [
    {
      title: 'Name',
      dataIndex: 'fname',
      key: 'fname',
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: 'Mobile',
      dataIndex: 'mobile',
      key: 'mobile',
    },
    {
      title: 'Username',
      dataIndex: 'username',
      key: 'username',
    },
    {
      title: 'Ticket Numbers',
      dataIndex: 'ticketNumbers',
      key: 'ticketNumbers',
      render: (tickets) => (
        tickets.length > 0 ? (
          tickets.map((ticket, index) => (
            <Tag color="blue" key={index}>
              {ticket}
            </Tag>
          ))
        ) : (
          <Tag color="red">No Tickets</Tag>
        )
      ),
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={users}
      rowKey="_id"
    />
  );
};

export default UserData;
